import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () =>
        import ('@/views/pc/index'),
    },
    {
      path: '/dangwu',
      name: 'Dangwu',
      component: () =>
        import ('@/views/pc/dangwu'),
    },
    {
      path: '/news',
      name: 'News',
      component: () =>
        import ('@/views/pc/news'),
    },
    {
      path: '/newsDetail',
      name: 'NewsDetail',
      component: () =>
        import ('@/views/pc/newsDetail'),
    },
    { //集团介绍
      path: '/intro',
      name: 'Intro',
      component: () =>
        import ('@/views/pc/intro'),
    },
    {
      //领带风采
      path: '/fengcai',
      name: 'Fengcai',
      component: () =>
        import ('@/views/pc/fengcai'),
    },
    {
      //搜索
      path: '/search',
      name: 'Search',
      component: () =>
        import ('@/views/pc/search'),
    },
    {
      //联系我们
      path: '/contact',
      name: 'Contact',
      component: () =>
        import ('@/views/pc/contact'),
    },
    {
      //文化
      path: '/wenhua',
      name: 'Wenhua',
      component: () =>
        import ('@/views/pc/wenhua'),
    },
    {
      //移动首页
      path: '/m',
      name: 'M_index',
      component: () =>
        import ('@/views/mobile/index'),
    },
    {
      //移动新闻
      path: '/m/news',
      name: 'M_news',
      component: () =>
        import ('@/views/mobile/news'),
    },
    {
      //移动新闻
      path: '/m/newsDetail',
      name: 'M_newsDetail',
      component: () =>
        import ('@/views/mobile/newsDetail'),
    },
    {
      //集团介绍
      path: '/m/intro',
      name: 'M_intro',
      component: () =>
        import ('@/views/mobile/intro'),
    },
    {
      //fengcai
      path: '/m/fengcai',
      name: 'M_fengcai',
      component: () =>
        import ('@/views/mobile/fengcai'),
    },
    {
      //fengcai
      path: '/m/wenhua',
      name: 'M_wenhua',
      component: () =>
        import ('@/views/mobile/wenhua'),
    },
    {
      //dangwu
      path: '/m/dangwu',
      name: 'M_dangwu',
      component: () =>
        import ('@/views/mobile/dangwu'),
    },
    {
      //联系我们
      path: '/m/contact',
      name: 'M_contact',
      component: () =>
        import ('@/views/mobile/contact'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js